// import emoji from 'react-easy-emoji';

// import googlelogo from './assets/img/icons/common/google.svg'
// import github from './assets/img/icons/common/github.svg'
// import airbnb from './assets/img/icons/common/airbnbLogo.png'
import lc from "./assets/img/icons/common/lc.png";
import bad from "./assets/img/icons/common/bad.png";
import sway from "./assets/img/icons/common/Tekmadev_Logo.svg";
import cv from "./assets/docs/2024OctShajeedCV.pdf";

export const greetings = {
  name: "Shajeed Islam",
  title: "Hi all, I'm Shajeed",
  description:
    "A passionate Full Stack Developer and Mobile App Developer having experience in building Web applications with JavaScript / Reactjs / Nodejs / PHP / Java / React Native for Mobile App and some other cool libraries and frameworks.",
  resumeLink: cv,
};

export const openSource = {
  githubUserName: "Sajistreo3",
};

export const contact = {};

export const socialLinks = {
  mail: "mailto:kazishajeed@gmail.com",
  // "facebook": "https://www.facebook.com/sajeed99",
  instagram: "https://www.instagram.com/its.shajeed",
  twitter: "https://x.com/itsShajeed",
  github: "https://github.com/Sajistreo3",
  linkedin: "https://www.linkedin.com/in/sajistreo3/",
};

export const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications",
    "⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks",
    "⚡ Integration of third party services such as AWS / Firebase / Vercel",
  ],

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "vscode-icons:file-type-html",
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "vscode-icons:file-type-css",
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "logos:javascript",
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "vscode-icons:file-type-reactjs",
    },
    {
      skillName: "nextjs",
      fontAwesomeClassname: "vscode-icons:file-type-light-next",
    },
    {
      skillName: "reactNative",
      fontAwesomeClassname: "vscode-icons:file-type-reactjs",
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "logos:nodejs-icon",
    },
    {
      skillName: "PHP",
      fontAwesomeClassname: "vscode-icons:file-type-php",
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "vscode-icons:file-type-java",
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "vscode-icons:file-type-swift",
    },
    {
      skillName: "CSharp",
      fontAwesomeClassname: "vscode-icons:file-type-csharp",
    },
    {
      skillName: "MySQL",
      fontAwesomeClassname: "vscode-icons:file-type-mysql",
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "vscode-icons:file-type-sql",
    },
    {
      skillName: "mongoDB",
      fontAwesomeClassname: "vscode-icons:file-type-mongo",
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "logos:firebase",
    },
    {
      skillName: "git",
      fontAwesomeClassname: "logos:git-icon",
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "vscode-icons:file-type-npm",
    },
    {
      skillName: "XML",
      fontAwesomeClassname: "vscode-icons:file-type-xml",
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "logos:docker-icon",
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "logos:sass",
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "logos:typescript-icon",
    },
    // {
    //   skillName: 'flutter',
    //   fontAwesomeClassname: 'logos:flutter',
    // },
    {
      skillName: "aws",
      fontAwesomeClassname: "logos:aws",
    },
    {
      skillName: "python",
      fontAwesomeClassname: "logos:python",
    },
  ],
};

export const SkillBars = [
  {
    Stack: "Frontend/Design", //Insert stack or technology you have experience in
    progressPercentage: "90", //Insert relative proficiency in percentage
  },
  {
    Stack: "Backend",
    progressPercentage: "70",
  },
  {
    Stack: "Programming",
    progressPercentage: "80",
  },
];

export const educationInfo = [
  {
    schoolName: "Herzing College",
    subHeader: "Full-Stack Developer",
    duration: "June 2019 - August 2020",
    desc: "This Institution trained me to become a Full-stack developer",
    descBullets: [
      "As for front-end, I mainly learned Web-dev using React HTML and CSS",
      "On the Back-end side, I have learned Java and PHP with OOP",
    ],
  },
  {
    schoolName: "Ecole National D'Aerotechnique",
    subHeader: "DEC Genie Aerospacial",
    duration: "January 2017 - May 2018",
    desc: "Learned in aeronautics ",
    descBullets: [
      "Learned about Engines",
      "Learned about aerodynamics and more",
    ],
  },
];

export const experience = [
  {
    role: "Freelance Full-Stack Developer",
    company: "Tekmadev",
    companylogo: sway,
    date: "July 2019 – Present",
    desc: "As a Freelance Full-Stack Developer at Tekmadev, I specialize in tailoring digital solutions that perfectly align with my clients' needs. Leveraging a rich toolkit that includes Java for software development, PHP for CMS websites, and React Native for mobile applications, I pride myself on delivering high-quality, scalable, and customizable solutions. Each project serves as an opportunity for me to exceed client expectations and solidify my reputation in the tech industry.",
    descBullets: [
      "Proficiency in delivering custom software solutions using Java",
      "Expertise in CMS development using PHP",
      "Hands-on experience in mobile app development using React Native",
      "Strong client communication and requirement analysis",
      "Proven track record of project delivery within tight deadlines",
    ],
  },
  {
    role: "Full-Stack Web Developer",
    company: "Linen Chest",
    companylogo: lc,
    date: "August 2021 – August 2023",
    desc: "As a Full-Stack Web Developer at Linen Chest, I've significantly expanded my skill set. Specializing in Magento 2 for backend development, I've also gained substantial experience in ReactJS on the frontend. The role has provided me with a multi-faceted understanding of E-commerce development and has refined my proficiency in PHP, Magento 2, and ReactJS—all within an Agile Scrum methodology.",
    descBullets: [
      "Profound understanding of E-commerce development",
      "Deep experience with backend technologies like PHP and Magento 2",
      "Hands-on experience with frontend technologies, particularly ReactJS",
      "Agile and Scrum methodologies for efficient project management",
      "Enhanced debugging and problem-solving skills",
    ],
  },
  {
    role: "Junior Full-Stack Developer",
    company: "Brossard App Design",
    companylogo: bad,
    date: "August 2020 – March 2022",
    desc: "In my role as a Junior Full-Stack Developer at Brossard App Design, I was entrusted with a variety of development tasks that enriched my technical portfolio. My hands-on experience with mobile app development using React Native complemented my web development skills in PHP, NodeJS, and JavaScript. This period served as an intense learning curve, sharpening my abilities across multiple technologies and frameworks.",
    descBullets: [
      "Mobile app development using React Native",
      "Versatile web development skills in PHP, NodeJS, and JavaScript",
      "Understanding of full-stack development practices",
      "Experience in cross-platform application development",
    ],
  },

  // {
  //   role: 'Software Engineer Intern',
  //   company: 'Airbnb',
  //   companylogo: airbnb,
  //   date: 'Jan 2015 – Sep 2015',
  //   desc:
  //     'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  // },
];

export const projects = [
  {
    name: "Promptarium",
    desc: "Promptarium is an open-source platform where users can explore, create, and share AI-powered prompts. Built using Next.js and integrated with MongoDB for database management, the platform leverages AI tools to assist users in generating effective prompts.",
    descBullets: [
      "Interactive posts featuring prompts and tags",
      "Challenges: Building a seamless real-time interaction system using Next.js and MongoDB to handle user-generated content.",
      "Prompt Creation: Users can create their own prompts and share them with the community.",
      "Google Authentication for secure user login.",
      "Advanced Search functionality that lets users search prompts by username, tags, or prompt content",
      "Prompt Discovery & Creation: Users can browse and contribute to a growing library of prompts",
    ],
    link: {
      name: "Web App",
      url: "http://promptarium.vercel.app",
    },
  },
  {
    name: "Sofan",
    desc: "The project, Sofan, is an all-encompassing NFT marketplace geared towards athletes. Built using React for the frontend and Firebase for the backend, it offers a range of functionalities beyond a simple marketplace. It also acts as a social media platform where users can submit posts, participate in polls, and engage with one another through likes, comments, and shares.",
    descBullets: [
      "Interactive posts featuring polls",
      "Curated NFT collections exclusively from athletes",
      "Customizable user dashboard",
      "Real-time chat system",
      "Complete CRUD operations powered and hosted by Firebase",
      "A variety of specialized pages such as Home, Profile, Feed, Athletes, Events, and Suggestions",
    ],
    link: {
      name: "Website",
      url: "https://www.sofan.app/",
    },
  },
  {
    name: "Coq O Bec Restaurant",
    desc: "Coq-O-Bec Gouin is a restaurant website designed to showcase a variety of chicken dishes and bakery items. Built with modern web technologies, it focuses on delivering a user-friendly experience for customers to explore the menu and connect with the restaurant.",
    descBullets: [
      "Responsive Design: Optimized for both desktop and mobile users.",
      "Dynamic Menu: Easily updateable sections for dishes and bakery items.",
      "Contact & Location Integration: Google Maps integration for easy navigation.",
      "Custom CMS: Backend for managing content and updating site information.",
      "Daily Operations Details: Showcasing opening hours and services.",
    ],
    link: {
      name: "Website",
      url: "https://www.coqobecgouin.com",
    },
  },
  {
    name: "Linen Chest",
    desc: "Linen Chest is a dynamic E-commerce website developed on the Magento 2 platform, using PHP for backend operations and React for the frontend. The project encompasses various intricate features ranging from cart functionalities to admin panels, all designed to offer an intuitive shopping experience.",
    descBullets: [
      "Innovative feature development and idea implementation",
      "Backend development using PHP and Magento 2 following MVC architecture",
      "Advanced cart functionalities using React JS with hooks",
      "Stringent bug fixes and troubleshooting",
      "Customizable admin panels created programmatically for streamlined management",
    ],
    link: {
      name: "Website",
      url: "https://www.linenchest.com/",
    },
  },
  {
    name: "FyKnow",
    desc: "FyKnow is an AI-powered financial management platform that combines smart banking features with ethical and Islamic finance principles. Built with modern web technologies, the platform offers a comprehensive suite of money management tools while maintaining Sharia compliance.",
    descBullets: [
      "Developed responsive landing page showcasing platform features",
      "Implemented AI-driven budgeting and expense tracking interfaces",
      "Integrated biometric authentication for enhanced security",
      "Created user-friendly interfaces for bill splitting and group expenses",
      "Ensured compliance with both Canadian financial regulations and Islamic finance principles",
    ],
    link: {
      name: "Website",
      url: "https://www.fyknow.com",
    },
  },
  {
    name: "Carpet Masters",
    desc: "Carpet Masters is a responsive and user-friendly website designed to showcase professional cleaning services. The platform highlights various cleaning services while providing users with detailed information and simple navigation, all wrapped in a modern and professional design.",
    descBullets: [
      "Developed a fully responsive website optimized for all devices",
      "Implemented smooth animations for enhanced user experience",
      "Created an integrated contact form system",
      "Designed clear service presentation sections",
      "Optimized for accessibility and user engagement",
    ],
    link: {
      name: "Website",
      url: "https://www.carpetmasters.co",
    },
  },
  {
    name: "WhatsUp - Event Organizer",
    desc: "WhatsUp - Event Organizer is a robust mobile application designed to facilitate the organization of meetings and events. Developed using React Native, the app boasts a series of high-quality, reusable frontend components and a stable backend implemented with Firebase.",
    descBullets: [
      "Comprehensive backend built with Firebase",
      "Developed using React Native and a variety of libraries",
      "Reusable frontend components for buttons, texts, and various layouts",
      "Rigorous bug fixes and problem-solving",
      "Developed following Agile methodologies with Sprint cycles",
    ],
    link: {
      name: "Screen Shot",
      url: "https://drive.google.com/file/d/1At74CiFO1DVEH3mHnxXnZ7iiybynR75P/view?usp=share_link",
    },
  },
  {
    name: "GestionAHT",
    desc: "GestionAHT is a specialized web solution created for a client in the gas station business. It showcases the client's gas stations and team while offering a powerful backend. Developed using PHP, the platform provides a comprehensive user CRUD system and a unique evaluation system, allowing the client to perform inspections via mobile or PC and export the findings as PDFs.",
    descBullets: [
      "Showcases client's gas stations and team",
      "Backend development with PHP",
      "Robust user CRUD (Create, Read, Update, Delete) system",
      "Mobile and PC-friendly evaluation system",
      "PDF export capability for inspections",
    ],
  },
  {
    name: "Restaurant Delivery System",
    desc: "A Windows Software with Front-end using Java Swing and Back-end with Java using Object-Oriented Programming, structured in MVC.",
  },
  {
    name: "TimeBox",
    desc: "Participated in the Front-end development for a mobile application in React Native.",
  },
];
